<script setup lang="ts">
/**
 * Écran monté À LA PLACE de l'app quand le boot échoue (config runtime illisible
 * ou Keycloak injoignable) — spec §5.4, étape 7. Jamais de page blanche.
 *
 * Il ne dépend ni du router, ni de Pinia, ni du client HTTP : à ce stade, aucun
 * des trois n'est installé (`Button` n'en dépend pas non plus).
 */
import { Button } from '@/components/ui/button';

defineProps<{ message: string }>();

function reload(): void {
  window.location.reload();
}
</script>

<template>
  <div class="flex min-h-screen items-center justify-center bg-pbg text-ptext font-sans px-4">
    <div class="max-w-md w-full text-center space-y-6">
      <div class="space-y-2">
        <h1 class="text-[22px] font-medium tracking-tight">
          Le portail n'a pas pu démarrer
        </h1>
        <p class="text-[13px] text-ptext-3">
          {{ message }}
        </p>
      </div>

      <Button type="button" @click="reload">
        Réessayer
      </Button>
    </div>
  </div>
</template>
